/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Directory_Hubs_Signals_Geo_Dim_Trust_EeatInputs */

const en_directory_hubs_signals_geo_dim_trust_eeat = /** @type {(inputs: Directory_Hubs_Signals_Geo_Dim_Trust_EeatInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`E-E-A-T signals: authorship, dates, consistent brand identity, and linked privacy and terms pages.`)
};

const zh_directory_hubs_signals_geo_dim_trust_eeat = /** @type {(inputs: Directory_Hubs_Signals_Geo_Dim_Trust_EeatInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`E-E-A-T 信任信号：作者信息、日期、一致的品牌身份、隐私与条款页链接。`)
};

/**
* | output |
* | --- |
* | "E-E-A-T signals: authorship, dates, consistent brand identity, and linked privacy and terms pages." |
*
* @param {Directory_Hubs_Signals_Geo_Dim_Trust_EeatInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const directory_hubs_signals_geo_dim_trust_eeat = /** @type {((inputs?: Directory_Hubs_Signals_Geo_Dim_Trust_EeatInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Directory_Hubs_Signals_Geo_Dim_Trust_EeatInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_directory_hubs_signals_geo_dim_trust_eeat(inputs)
	return zh_directory_hubs_signals_geo_dim_trust_eeat(inputs)
});
export { directory_hubs_signals_geo_dim_trust_eeat as "directory.hubs.signals.geo.dim.trust_eeat" }